<template>
  <div class="paging">
    <div
      class="paging__button button-left-last"
      :class="{ button_disabled: isLeftButtonDisabled }"
      role="button"
      @click="hardLeftClickHandler"
    ></div>
    <div
      class="paging__button button-left"
      :class="{ button_disabled: isLeftButtonDisabled }"
      role="button"
      @click="leftClickHandler"
    ></div>
    <div
      role="button"
      class="paging__button button-number"
      v-for="page in pages"
      :key="page"
      @click="pagingClickHandler(page)"
      :class="{page_selected: page === (selectedPageIndex + 1)}"
    >{{page}}</div>
    <div
      class="paging__button button-right"
      :class="{ button_disabled: isRightButtonDisabled }"
      role="button"
      @click="rightClickHandler"
    ></div>
    <div class="paging__button button-right-last" @click="hardRightClickHandler"></div>
  </div>
</template>

<script>
import EventBus from "../EventBus.js";
import {RESET_PAGING_EVENT} from "../js/event.js";

const CURRENT_CHANGE_EVENT = "currentChange";
const PAGES_VISIBLE_COUNT = 5;
export default {
  name: "paging-component",
  props: {
    pageSize: { type: Number, required: true },
    total: { type: Number, required: true }
  },
  data() {
    return {
      selectedPageIndex: 0,
      currentIndex: 0,
      pageCollection: []
    };
  },
  mounted() {
    EventBus.$on(RESET_PAGING_EVENT, () => {
        this.selectedPageIndex = 0;
        this.currentIndex = 0;
      });
  },
  destroyed() {
      EventBus.$off(RESET_PAGING_EVENT);
    },
  computed: {
        pages() {
          if (this.pageSize && this.total) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.pageCollection = Array.from({length: Math.ceil(this.total / this.pageSize)},
               (_, i) => i + 1);
          }
          return this.pageCollection.filter(
            (item, index) =>
              index >= this.currentIndex &&
              Math.abs(index - this.currentIndex) < PAGES_VISIBLE_COUNT
          );
        },
    isLeftButtonDisabled() {
      return this.selectedPageIndex === 0;
    },
    isRightButtonDisabled() {
      return this.selectedPageIndex === this.pageCollection.length - 1;
    }
  },
  watch: {
    total() {
      this.selectedPageIndex = 0;
    }
  },
  methods: {
    hardLeftClickHandler() {
      if (this.isLeftButtonDisabled) {
        return;
      }
      this.currentIndex = 0;
      this.selectedPageIndex = 0;
      this.sendPageChangeEvent();
    },
    leftClickHandler() {
      if (this.isLeftButtonDisabled) {
        return;
      }
      if (
        this.currentIndex > 0 &&
        this.currentIndex === this.selectedPageIndex
      ) {
        this.currentIndex =
          this.currentIndex - PAGES_VISIBLE_COUNT < 0
            ? 0
            : this.currentIndex - PAGES_VISIBLE_COUNT;
      }

      if (this.selectedPageIndex > 0) {
        this.selectedPageIndex -= 1;
        this.sendPageChangeEvent();
      }
    },
    rightClickHandler() {
      if (this.isRightButtonDisabled) {
        return;
      }
      if (
        this.currentIndex < this.pageCollection.length - PAGES_VISIBLE_COUNT &&
        this.currentIndex + PAGES_VISIBLE_COUNT === this.selectedPageIndex + 1
      ) {
        this.currentIndex =
          this.pageCollection.length -
            (this.currentIndex + PAGES_VISIBLE_COUNT) <
          PAGES_VISIBLE_COUNT
            ? this.pageCollection.length - PAGES_VISIBLE_COUNT
            : this.currentIndex + PAGES_VISIBLE_COUNT;
      }

      if (this.selectedPageIndex < this.pageCollection.length - 1) {
        this.selectedPageIndex += 1;
        this.sendPageChangeEvent();
      }
    },
    hardRightClickHandler() {
      if (this.isRightButtonDisabled) {
        return;
      }
      if (this.pageCollection.length <= PAGES_VISIBLE_COUNT) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = this.pageCollection.length - PAGES_VISIBLE_COUNT;
      }
      this.selectedPageIndex = this.pageCollection.length - 1;
      this.sendPageChangeEvent();
    },
    pagingClickHandler(pageIndex) {
      this.selectedPageIndex = pageIndex - 1;
      this.sendPageChangeEvent();
    },
    sendPageChangeEvent() {
      this.$emit(CURRENT_CHANGE_EVENT, this.selectedPageIndex + 1);
    }
  }
};
</script>
<style scoped lang="scss">
  @import "../styles/hpConstant.scss";
  @import "../styles/hpCommon.scss";

.paging {
  display: flex;
  flex-direction: row;
  align-items: center;

  &__button {
    min-width: 20px;
    height: 20px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.page_selected {
  color: $hpLightBlue !important;
}

.button-number {
  margin-right: 4px;

  font-size: 1.14rem;
  text-align: center;

  cursor: pointer;
}

.button-number:last-child {
  margin-right: 7px;
}

.button-left-last {
  background-image: url("../assets/images/pagination/pagination_first.png");
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center center;

  cursor: pointer;

  margin-right: 5px;
}

.button-left {
  background-image: url("../assets/images/pagination/pagination_previous.png");
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center center;
  cursor: pointer;
  margin-right: 7px;
}

.button-right {
  background-image: url("../assets/images/pagination/pagination_next.png");
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center center;
  cursor: pointer;
  margin-right: 5px;
}

.button-right-last {
  background-image: url('../assets/images/pagination/pagination_last.png');
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-position: center center;
  cursor: pointer;
}

.button_disabled {
  opacity: 0.3;
  cursor: text;
}
</style>